export var ReceiptType;
(function (ReceiptType) {
    ReceiptType[ReceiptType["PURCHASE_ORDER"] = 1] = "PURCHASE_ORDER";
    ReceiptType[ReceiptType["TRANSFER_ORDER"] = 2] = "TRANSFER_ORDER";
    ReceiptType[ReceiptType["RETURN"] = 3] = "RETURN";
})(ReceiptType || (ReceiptType = {}));
//# sourceMappingURL=receipt-type.js.map